import ExtractionReducerAction from '@/pages/takeoff/layouts/extraction/context/extraction-reducer-action.ts';
import ProjectExtractionSheets from './models/project-extraction-sheets.ts';
import ExtractionSheetArticleMeasuresElement
    from "@/pages/takeoff/layouts/extraction/context/models/article-elements/extraction-sheet-article-measures-element.ts";
import ExtractionSheetArticle3DElement
    from "@/pages/takeoff/layouts/extraction/context/models/article-elements/extraction-sheet-article-3D-element.ts";

const extractionReducer: (draft: ProjectExtractionSheets | null, action: ExtractionReducerAction) => void = (draft, action) => {
    switch (action.type) {
        case 'createNew': {
            return new ProjectExtractionSheets();
        }
        
        case 'hydrate': {
            return ProjectExtractionSheets.fromDto(action.payload.dto, action.payload.projectMeasures, action.payload.measureTypes, action.payload.projectIndicatorsData);
        }
        
        case 'setIsDirty': {
            if (draft === null) return draft;
            draft.setIsDirty(action.payload.dirty);
            return draft;
        }
        
        /* Feuilles */
        
        case 'addSheet': {
            if (draft === null) return draft;
            draft.addSheet(action.payload.name);
            draft.setIsDirty(true);
            return draft;
        }

        case 'updateSheetName': {
            if (draft === null) return draft;
            const sheet = draft.getSheetById(action.payload.id);
            if (!sheet) return draft;
            sheet.updateName(action.payload.newName);
            draft.setIsDirty(true);
            return draft;
        }

        case 'removeSheet': {
            if (draft === null) return draft;
            draft.removeSheet(action.payload.id);
            draft.setIsDirty(true);
            return draft;
        }
        
        /* Nœuds */
        
        case 'addNode': {
            if (draft === null) return draft;
            const sheet = draft.getSheetById(action.payload.sheetId);
            if (!sheet) return draft;
            sheet.addNode(action.payload.nodeName);
            draft.setIsDirty(true);
            return draft;
        }
        
        case 'updateNodeName': {
            if (draft === null) return draft;
            const sheet = draft.getSheetById(action.payload.sheetId);
            if (!sheet) return draft;
            const node = sheet.getNodeById(action.payload.nodeId);
            if (!node) return draft;
            node.updateName(action.payload.newName);
            draft.setIsDirty(true);
            return draft;
        }
        
        case 'addSubNode': {
            if (draft === null) return draft;
            const sheet = draft.getSheetById(action.payload.sheetId);
            const node = sheet?.getNodeById(action.payload.nodeId);
            if (!node) return draft;
            node.addChildrenNode(action.payload.subNodeName);
            draft.setIsDirty(true);
            return draft;
        }
        
        case 'removeNode': {
            if (draft === null) return draft;
            const sheet = draft.getSheetById(action.payload.sheetId);
            if (!sheet) return draft;
            sheet.removeNode(action.payload.nodeId);
            draft.setIsDirty(true);
            return draft;
        }
        
        /* Articles */
        case 'addArticle': {
            if (draft === null) return draft;
            const sheet = draft.getSheetById(action.payload.sheetId);
            const node = sheet?.getNodeById(action.payload.nodeId);
            if (!node) return draft;
            node.addArticle(action.payload.articleName);
            draft.setIsDirty(true);
            return draft;
        }
        
        case 'updateArticleName': {
            if (draft === null) return draft;
            const sheet = draft.getSheetById(action.payload.sheetId);
            if (!sheet) return draft;
            const article = sheet.getArticleById(action.payload.articleId);
            if (!article) return draft;
            article.updateArticleName(action.payload.articleName);
            draft.setIsDirty(true);
            return draft;
        }
        
        case 'linkMeasuresToArticle': {
            if (draft === null) return draft;
            const sheet = draft.getSheetById(action.payload.sheetId);
            if (!sheet) return draft;
            const article = sheet.getArticleById(action.payload.articleId);
            if (!article) return draft;
            
            article.linkMeasures(action.payload.measureTypeId, action.payload.measureTypeName, action.payload.associatedStoreysIds, action.payload.measures, action.payload.defaultType, action.payload.defaultUnity);
            draft.setIsDirty(true);
            return draft;
        }
        
        case 'link3DToArticle' : {
            if(draft === null) return draft;
            
            const sheet = draft.getSheetById(action.payload.sheetId);
            if (!sheet) return draft;
            const article = sheet.getArticleById(action.payload.articleId);
            if (!article) return draft;
            
            article.link3D(action.payload.indicatorDefKeyName, action.payload.associatedStoreysIds, action.payload.indicators);
            draft.setIsDirty(true);
            return draft;
        }
        
        case 'removeArticle': {
            if (draft === null) return draft;
            const sheet = draft.getSheetById(action.payload.sheetId);
            if(!sheet) return draft;
            sheet.removeArticle(action.payload.articleId);
            draft.setIsDirty(true);
            return draft;
        }
        
        case 'updateArticleData': {
            if (draft === null) return draft;
            const sheet = draft.getSheetById(action.payload.sheetId);
            if (!sheet) return draft;
            const article = sheet.getArticleElementById(action.payload.articleElementId);
            if (!article) return draft;
            
            if(article instanceof ExtractionSheetArticleMeasuresElement)
                article.updateElement(action.payload.dataKey, action.payload.operation);
            else if(article instanceof ExtractionSheetArticle3DElement)
                article.updateElement(action.payload.operation);
            
            draft.setIsDirty(true);
            return draft;
        }

        default:
            return draft;
    }
};

export default extractionReducer;